import React from 'react'
import FloorsSkeleton from "./FloorsSkeleton";
import KeyboardSkeleton from "./KeyboardSkeleton";

const FilterSectionSkeleton = ({floorfilter, search}) => {
  return (
    <div style={{lineHeight: 1}}>
      {floorfilter  && <FloorsSkeleton /> }
      {search && <KeyboardSkeleton />}
    </div>
  )
}

export default FilterSectionSkeleton
